import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CheckBoxCustomHelper from '../../../helpers/CheckBoxCustomHelper';
import {
    renderFirstNameField,
    renderSecondLastNameField,
    renderLastNameField,
    renderEmailField,
    renderMobilePhoneField,
    renderWeightField,
    renderDateOfBirthField,
    renderGenericCheckboxGroup,
    renderGenericTextField,
    renderOptionsField
} from '../../../helpers/form/fields'
import { reduxForm, getFormValues } from 'redux-form';
import { account_update } from '../../../redux/actions/accountActions';

import classNames from "classnames";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import { withStyles } from "@material-ui/core/styles";
const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon
};

const styles1 = theme => ({
    success: {
        backgroundColor: green[600]
    },
    error: {
        backgroundColor: theme.palette.error.dark
    },
    info: {
        backgroundColor: theme.palette.primary.dark
    },
    warning: {
        backgroundColor: amber[700]
    },
    icon: {
        fontSize: 20
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing.unit
    },
    message: {
        display: "flex",
        alignItems: "center"
    }
});

function MySnackbarContent(props) {
    const { classes, className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];

    return (
        <SnackbarContent
            className={classNames(classes[variant], className)}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" className={classes.message}>
                    <Icon className={classNames(classes.icon, classes.iconVariant)} />
                    {message}
                </span>
            }
            action={[
                <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    className={classes.close}
                    onClick={onClose}
                >
                    <CloseIcon className={classes.icon} />
                </IconButton>
            ]}
            {...other}
        />
    );
}

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

class ConsumidorForm extends Component {
    state = {
        store: null
    };

    componentDidMount() {
        this.initializeForm();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.account.data !== prevProps.account.data) {
            this.initializeForm(this.props.account.data)
        }
    }
    openNotification = (values) => {
        values && this.setState({ open: true });

    }
    handleSubmit = (values) => {
        this.props.dispatch(
            account_update(values, this.props.auth.user_id, this.props.auth.token, this.openNotification)
        );
    }

    initializeForm(user) {
        if (!user) {
            user = this.props.account.data;
        }
        console.log("user", user);
        const initialFormState = {
            first_name: user.user.first_name,
            last_name: user.user.last_name,
            second_last_name: user.user.second_last_name,
            email: user.user.email,
            mobile_phone_number: user.mobile_phone_number,
            birthday: user.birthday,
            work_status: user.work_status && user.work_status.toString(),
            how_you_know_about_cosmocare: user.how_you_know_about_cosmocare,
            using_social_networks: user.using_social_networks,
            social_networks: user.social_networks,
            social_networks_other: user.social_networks_other,
            social_security_affiliation: user.social_security_affiliation === false ? "1" : "2",
            why_participate_in_tests: user.why_participate_in_tests,
            // new fields,
            has_tattoos: user.has_tattoos === false ? "1" : "2",
            has_tattoos_value: user.has_tattoos_value,
            weight: user.weight,
            wear_glasses: user.wear_glasses === false ? "1" : "2",
            wear_contact_lenses: user.wear_contact_lenses === false ? "1" : "2",
            had_recent_surgery: user.had_recent_surgery === false ? "1" : "2",
            had_recent_surgery_value: user.had_recent_surgery_value,
            enrolled_in_other_center: user.enrolled_in_other_center === false ? "1" : "2",
            health_and_care_products: user.health_and_care_products,
            consumer_usual_products:user.consumer_usual_products,
            consumer_usual_products_other: user.consumer_usual_products_other,
            use_hair_removal_products: user.use_hair_removal_products === false ? "1" : "2",
            hair_removal_zones: user.hair_removal_zones,
            hair_removal_products_list: user.hair_removal_products_list,
            hair_removal_methods:user.hair_removal_methods,
            had_laser_hair_removal: user.had_laser_hair_removal === "false" ? "1" : "2",
            had_laser_hair_removal_user_input: user.had_laser_hair_removal_user_input
        };
        this.props.initialize(initialFormState);
    }
    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ open: false });
    };
    render() {
        const { account, common, formValues, pristine, submitting, handleSubmit } = this.props;
        if (!formValues) {
            return <div></div>
        }
        let accData = account.data;
        console.log(accData);
        const options = [
            { id: 1, value: 'Mañana', label: 'Mañana' },
            { id: 2, value: 'Tarde', label: 'Tarde' },
        ]
        return (
            <React.Fragment>
                <form onSubmit={handleSubmit(this.handleSubmit.bind(this))} autocomplete="off">
                    <Grid container spacing={8} alignItems="flex-end">
                        <Grid item xs={12}>
                            {renderWeightField('Peso (kg)', 'weight')}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subheading" style={{ marginTop: 15 }}>
                                ¿Llevas gafas?
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {renderOptionsField({
                                name: 'wear_glasses',
                                options: this.props.common.yesno || [],
                            })}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subheading" style={{ marginTop: 15 }}>
                                ¿Llevas lentillas?
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {renderOptionsField({
                                name: 'wear_contact_lenses',
                                options: this.props.common.yesno || [],
                            })}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subheading" style={{ marginTop: 15 }}>
                                ¿Estás apuntado/a a otro centro de pruebas cosméticas?
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {renderOptionsField({
                                name: 'enrolled_in_other_center',
                                options: this.props.common.yesno || [],
                            })}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subheading" style={{ marginTop: 15 }}>
                                ¿Te han operado durante los últimos 12 meses?
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {renderOptionsField({
                                name: 'had_recent_surgery',
                                options: this.props.common.yesno || [],
                            })}
                            {
                                formValues.had_recent_surgery == "2" && renderGenericTextField('¿Motivo?', 'had_recent_surgery_value')
                            }
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="subheading" style={{ marginTop: 15 }}>
                                Selecciona los productos de la siguiente lista que uses habitualmente
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {renderGenericCheckboxGroup({
                                name: 'consumer_usual_products',
                                options: this.props.common.consumer_usual_products || [],
                                fullWidth: true
                            })}
                             {
                                formValues.consumer_usual_products &&
                                formValues.consumer_usual_products.map((value) => (value === 43 && renderGenericTextField('Otro', 'consumer_usual_products_other')))
                            }
                        </Grid>

                   
                        <Grid item xs={12}>
                            <Typography variant="subheading" style={{ marginTop: 15 }}>
                                ¿Utiliza productos para depilarse?
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {renderOptionsField({
                                name: 'use_hair_removal_products',
                                options: this.props.common.yesno || [],
                            })}
                        </Grid>
                        {
                            formValues.use_hair_removal_products == "2" &&
                            <React.Fragment>
                                <Grid item xs={12}>
                                    <Typography variant="subheading" style={{ marginTop: 15 }}>
                                        ¿Dónde? (zona)
                                        </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    {renderGenericCheckboxGroup({
                                        name: 'hair_removal_zones',
                                        options: this.props.common.hair_removal_zones || [],
                                        fullWidth: true
                                    })}
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="subheading" style={{ marginTop: 15 }}>
                                        ¿Qué producto?
                                        </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    {renderGenericCheckboxGroup({
                                        name: 'hair_removal_methods',
                                        options: this.props.common.hair_removal_methods || [],
                                        fullWidth: true
                                    })}
                                </Grid>
                            </React.Fragment>
                        }


                        <Grid item xs={12}>
                            <Typography variant="subheading" style={{ marginTop: 15 }}>
                                ¿Tienes tatuajes?
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {renderOptionsField({
                                name: 'has_tattoos',
                                options: this.props.common.yesno || [],
                            })}
                            {console.log(formValues.has_tattoos)}
                            {
                                formValues.has_tattoos == "2" && renderGenericTextField('Qué zona(s)', 'has_tattoos_value')
                            }
                        </Grid>
                       
                    </Grid>
                    <Grid container spacing={8} style={{ marginTop: '10%' }}>
                        <Grid item xs={12} align="center">
                            <Snackbar
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left"
                                }}
                                open={this.state.open}
                                autoHideDuration={3000}
                                onClose={this.handleClose}
                            >
                                <MySnackbarContentWrapper
                                    onClose={this.handleClose}
                                    variant="success"
                                    message="This is a success message!"
                                />
                            </Snackbar>
                            <Button type="submit" variant="contained" color="primary" disabled={pristine || submitting}>
                                Save
                            </Button>
                        </Grid>
                    </Grid>

                </form>

                <Grid item xs={12}>
                    <label className='form__form-group-label'>Nombre *</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            <span>{accData.user.first_name}</span>
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Primer apellido *</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            <span>{accData.user.last_name}</span>
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Segundo apellido</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            <span>{accData.user.second_last_name}</span>
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Dirección de envío de las muestras:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.has_different_delivery_address ? <span>Si</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />
                </Grid>


                <Grid item xs={12}>
                    <label className='form__form-group-label'>Disponibilidad horaria para la recepción de los productos:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={options}
                            data={accData.preferred_delivery_time}
                        />
                    </div> <hr />
                </Grid>



                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Hay un portero en tu edificio (o alguien que pueda recibir paquetes)?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.address_has_doorkeeper === "1" ? <span>Si</span> : <span>No</span>}
                        </div>
                    </div><hr />
                </Grid>


                <Grid item xs={12}>
                    <label className='form__form-group-label'>Actividad Laboral:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.work_status}
                            data={accData.work_status}
                        />
                    </div><hr />
                </Grid>

                <Grid item xs={12}>
                    <label className='form__form-group-label'> ¿Cómo has conocido CosmoCare?:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.how_you_know_about_cosmocare}
                            data={accData.how_you_know_about_cosmocare}
                        />
                    </div><hr />
                    <Grid item xs={12}>
                    <label className='form__form-group-label'>Otro:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            <span>{accData.how_you_know_about_cosmocare_other}</span>
                        </div>
                    </div>
                    <hr />
                </Grid>
                </Grid>

                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Utilizas redes sociales?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.using_social_networks ? <span>Si</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />
                </Grid>

                {accData.using_social_networks === true &&
                    <Grid item xs={12}>
                        <label className='form__form-group-label'>¿Di cuál o cuáles?:</label>
                        <div className='form__form-group-field'>
                            <CheckBoxCustomHelper
                                options={common.social_networks}
                                data={accData.social_networks}
                            />
                        </div>
                        <hr />

                    </Grid>

                }

                {/* <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Estás afiliado/a a la Seguridad Social?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.social_security_affiliation ? <span>Si</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid> */}

                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Por qué te gustaría participar en estos tests?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            <span>{accData.why_participate_in_tests}</span>
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Presenta algún problema de salud de los que aparecen en la siguiente lista?:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.health_problems}
                            data={accData.health_problems}
                        />
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tomas de manera habitual (diaria, semanal…) alguno de los medicamentos de la siguiente lista?:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.you_take_medicine}
                            data={accData.you_take_medicine}
                        />
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Presenta alguna de las afecciones dermatológicas de las que aparecen en la siguiente lista?:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.derma_affections}
                            data={accData.derma_affections}
                        />
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Conjuntivitis:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.prone_to_conjunctivitis ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Herpes:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.prone_to_herpes ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Rinitis alérgica:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.prone_to_allergic_rhinitis ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Crisis de asma:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.prone_to_asthma_crisis ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Ha tenido alguna vez algún tipo de reacción de intolerancia a productos cosméticos?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.intolerance_reaction_cosmetics ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />
                </Grid>
                {accData.intolerance_reaction_cosmetics === true &&
                    <Grid item xs={12}>
                        <label className='form__form-group-label'>Ante qué producto(s):</label>
                        <div className='form__form-group-field'>
                            <div className='checkbox-value'>
                                <span>{accData.intolerance_reaction_cosmetics_value}</span>
                            </div>
                        </div>
                        <hr />
                    </Grid>
                }
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Especifica cuál es tu tipo de piel:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.skin_types}
                            data={accData.skin_type}
                        />
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Especifica la naturaleza de la piel de tu rostro:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.skin_nature}
                            data={accData.skin_nature}
                        />
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tienes la piel del rostro sensible (piel con reacciones de quemazón, sensación de
            tirantez, calentura, rojez o picor por cambios de temperatura, estrés,
                cambios hormonales, frío, viento, sol...)?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.sensitive_facial_skin ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿La piel del rostro tiene tendencia atópica (piel muy seca que reacciona ante la
                mínima agresión externa, como el viento, el frío, el estrés...)?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.facial_skin_atopic_tendency ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tu rostro presenta alguna de las características siguientes?:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.skin_characteristics}
                            data={accData.skin_characteristics}
                        />
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Especifica la naturaleza de tus labios:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.lips_nature}
                            data={accData.lips_nature}
                        />
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tienes los labios sensibles (posibles reacciones ante cambios de
                temperatura, estrés, frío, viento, sol...)?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.sensitive_lips ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Especifica la naturaleza de la piel de tu cuerpo:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.body_skin_nature}
                            data={accData.body_skin_nature}
                        />
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tienes la piel del cuerpo sensible? (piel con reacciones de quemazón, sensación de
            tirantez, calentura, rojez o picor por cambios de temperatura, estrés, cambios
                hormonales, frío, viento, sol...)?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.sensitive_body_skin ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tienes celulitis?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.have_cellulite ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                {accData.have_cellulite === true &&
                    <Grid item xs={12}>
                        <div className='form__form-group-field'>
                            <div className='checkbox-value'>
                                <CheckBoxCustomHelper
                                    options={common.cellulite_type}
                                    data={accData.have_cellulite_value}
                                />
                            </div>
                        </div>
                        <hr />
                    </Grid>
                }
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tienes manchas de pigmentación en el escote?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.has_pigmentation_spots_neckline ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Especifica la naturaleza de la piel de tus manos:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.hand_skin_nature}
                            data={accData.hand_skin_nature}
                        />
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tienes las manos sensibles (piel con reacciones de quemazón,
          sensación de tirantez, calentura, rojez o picor por cambios de temperatura,
              estrés, cambios hormonales, frío, viento, sol...)?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.has_sensitive_hands ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tienes manchas de pigmentación en las manos?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>

                            {accData.has_pigmentation_spots_on_hands ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tienes los ojos sensibles (reaccionan al viento, frío, sol...):</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>

                            {accData.has_sensitive_eyes ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Llevas gafas?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>

                            {accData.wear_glasses ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Llevas lentillas?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.wear_contact_lenses ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Has tenido alguna vez problemas oculares?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.had_eyes_problems ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tienes el cuero cabelludo sensible? (piel con reacciones de
          quemazón, sensación de tirantez, calentura, rojez o picor por cambios de
              temperatura, estrés, cambios hormonales, frío, viento, sol...):</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.has_sensitive_scalp ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />
                </Grid>

                <Grid item xs={12}>
                    <label className='form__form-group-label'>Especifica la naturaleza de tu cuero cabelludo:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.hair_and_scalp_nature}
                            data={accData.scalp_nature}
                        />
                    </div>
                    <hr />
                </Grid>

                <Grid item xs={12}>
                    <label className='form__form-group-label'>Especifica el estado de tu cabello:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.hair_state}
                            data={accData.hair_state}
                        />
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Especifica tu tipo de cabello:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.hair_type}
                            data={accData.hair_type}
                        />
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Especifica cuál es el color de tu cabello:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.hair_color}
                            data={accData.hair_color}
                        />
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Qué longitud tiene tu cabello?:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.hair_length}
                            data={accData.hair_length}
                        />
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tienes el pelo teñido o con mechas, o sueles teñírtelo?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.dyed_hair ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Sufres caída de cabello o alopecia?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.hair_loss ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tienes tendencia a tener caspa?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.hair_dandruff ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                {/* <Grid item xs={12}>
                    <label className='form__form-group-label'>Selecciona los productos de la siguiente lista que uses habitualmente:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.consumer_usual_products}
                            data={accData.consumer_usual_products}
                        />
                    </div>
                </Grid>
                <hr /> */}
                {/* <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Utilizas productos para depilarte?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.use_hair_removal_products ? <span>Si</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                {accData.use_hair_removal_products === true &&
                    <div>
                        <Grid item xs={12}>
                            <label className='form__form-group-label'>¿Dónde? (zona):</label>
                            <div className='form__form-group-field'>
                                <div className='checkbox-value'>
                                    <CheckBoxCustomHelper
                                        options={common.hair_zones}
                                        data={accData.hair_removal_zones}
                                    />
                                </div>
                            </div>
                        </Grid>
                        <hr />
                        <Grid item xs={12}>
                            <label className='form__form-group-label'>¿Qué método utilizas? (Escoge tantos como sea necesario):</label>
                            <div className='form__form-group-field'>
                                <div className='checkbox-value'>
                                    <CheckBoxCustomHelper
                                        options={common.hair_removal_methods}
                                        data={accData.hair_removal_methods}
                                    />
                                </div>
                            </div>
                        </Grid>
                        <hr />
                        <Grid item xs={12}>
                            <label className='form__form-group-label'>¿Dónde compras los productos cosméticos?:</label>
                            <div className='form__form-group-field'>
                                <div className='checkbox-value'>
                                    <CheckBoxCustomHelper
                                        options={common.buy_products_from}
                                        data={accData.buy_products_from}
                                    />
                                </div>
                            </div>
                        </Grid>
                        <hr />
                    </div>
                } */}
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Usas productos cosméticos bio, ecológicos u orgánicos?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.use_bio_products ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Eres fumador/a?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.is_smoking ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tienes tatuajes?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.has_tattoos ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                </Grid>
                <hr />
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Estás apuntado/a a otro centro de pruebas cosméticas?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.enrolled_in_other_center ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Te han operado durante los últimos 12 meses?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.had_recent_surgery ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
            </React.Fragment>
        )
    }
}
ConsumidorForm = reduxForm({
    form: 'consumidorForm',
    persistentSubmitErrors: false,
    // validate
})(ConsumidorForm)
ConsumidorForm = connect(state => ({
    account: state.account,
    auth: state.auth,
    common: state.common,
    formValues: getFormValues('consumidorForm')(state)
}))(ConsumidorForm);
export default ConsumidorForm;


// WEBPACK FOOTER //
// ./src/modules/account/forms/ConsumidorForm.js